export default "__VITE_ASSET__DcgUslOl__"